var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "adivare-results-loading",
    { attrs: { "show-spinner": false, fader: false } },
    [
      _c(
        "div",
        { class: ["row", { loading: _vm.waitingForHouses }] },
        [
          _vm.rentals !== undefined &&
          _vm.rentals !== null &&
          _vm.rentals.length !== 0
            ? _vm._l(_vm.rentals, function (rental, index) {
                return _c("adivare-list-item-wrapper", {
                  key: rental.id,
                  attrs: { index: index, rental: rental },
                })
              })
            : false === _vm.waitingForHouses
            ? _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "alert alert-info xs-mt-10" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("messages_nl.catalog.cta0", {
                            location: _vm.title,
                          })
                        ) +
                        "\n        "
                    ),
                    _vm.user === ""
                      ? [
                          _c(
                            "a",
                            {
                              staticStyle: { "font-weight": "bold" },
                              attrs: { href: _vm.path },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("messages_nl.catalog.cta1-1")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                " " + _vm.$t("messages_nl.catalog.cta1-2")
                              ) +
                              "\n        "
                          ),
                        ]
                      : _c(
                          "a",
                          {
                            staticStyle: { "font-weight": "bold" },
                            attrs: { href: _vm.path },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("messages_nl.catalog.cta2")) +
                                "\n        "
                            ),
                          ]
                        ),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("messages_nl.catalog.cta3", {
                            location: _vm.title,
                          })
                        ) +
                        "\n      "
                    ),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }